import type { Identity } from "@/domain/auth";

import type { DocsAudience } from "./catalog";

export type { DocsAudience };

const order: DocsAudience[] = ["account", "oidc", "tenant", "platform"];

export function canReadIntegrationDocs(identity: Pick<Identity, "roles"> | null | undefined): boolean {
  const roles = identity?.roles ?? [];
  return roles.includes("oidc_developer") || roles.includes("tenant_admin") || roles.includes("super_admin");
}

export function visibleDocAudiences(identity: Pick<Identity, "roles" | "permissions"> | null | undefined): DocsAudience[] {
  if (!canReadIntegrationDocs(identity)) return [];
  const roles = identity?.roles ?? [];
  const canManageTenant = roles.includes("tenant_admin") || roles.includes("super_admin");
  return order.filter((audience) => {
    if (audience === "account" || audience === "oidc") return true;
    if (audience === "tenant") return canManageTenant;
    return roles.includes("super_admin");
  });
}

export function docsHome(identity: Pick<Identity, "roles" | "permissions"> | null | undefined, pages: Array<{ audience: DocsAudience; slug: string }>): string {
  const allowed = new Set(visibleDocAudiences(identity));
  const first = pages.find((page) => allowed.has(page.audience));
  return first ? `/docs/${first.audience}/${first.slug}` : "/";
}
